<template>
  <el-button class="fullscreen-btn"
             round
             :icon="isFullScreen ? 'mdi mdi-fullscreen-exit' : 'mdi mdi-fullscreen'"
             @click="isFullScreen = !isFullScreen" />
</template>

<script>
import InspectorBus from '../InspectorBus';

export default {
  name: 'SceneFullScreenButton',
  data() {
    return {
      isFullScreen: false
    };
  },
  watch: {
    isFullScreen(value) {
      InspectorBus.isFullScreen = value;
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss">
.fullscreen-btn {
  height: 30px;
  padding: 2px 12px !important;
  margin-left: 10px;
  background-color: #fff;
  border: 1.5px solid #e2e2e2;

  i {
    font-size: 22px;
    color: #7c7c7c;

    @include breakpoint(lg-max) {
      font-size: 20px;
    }
  }

  &:hover,
  &:focus {
    background-color: #fff;
  }
}
</style>
